import * as React from "react";

export const CobrowsingContainer = () => {
  const schermDelenString = "Scherm delen";

  return (
    <>
      <div className="nav-item" data-id="CB57f28149569b0cf53d">
        <div className="cb_button cb_online">
          <span className="nav-link cb_chatbutton">{schermDelenString}</span>
        </div>
        <div className="cb_button cb_accepted">
          <span className="nav-link cb_chatbutton cb_chatbutton--active">{schermDelenString}</span>
        </div>
        <div className="cb_button cb_offline" />
      </div>
    </>
  );
};
